import React from "react";
import { css } from "@emotion/react";
// import { PulseLoader } from 'react-spinners';
import { Hourglass, Oval } from "react-loader-spinner";
import { BRAND, LOADER_COLORS } from "../../constant/theme";

const Loader = (props) => {
  const colspan = props.colspan;
  return (
    <tr>
      <td colSpan={colspan} className="center">
        <div
          style={{ display: "flex", justifyContent: "center", padding: "5px" }}
        >
          <Hourglass
            visible={true}
            height="25"
            width="25"
            ariaLabel="hourglass-loading"
            wrapperStyle={{}}
            wrapperClass=""
            colors={LOADER_COLORS}
          />
        </div>
      </td>
    </tr>
  );
};

export const OvalLoader = (props) => {
  const color = props.color || BRAND.primary;
  return (
    <span style={{ display: "flex", justifyContent: "center", padding: "5px" }}>
      <Oval
        visible={true}
        height="35"
        width="35"
        color={color}
        ariaLabel="oval-loading"
        wrapperStyle={{}}
        wrapperClass=""
      />
    </span>
  );
};

export const ModalLoader = (props) => {
  const visible = props.visible;
  if (!visible) return null;
  return (
    <div className="modal-loader-overlay">
      <Hourglass
        visible={true}
        height="30"
        width="30"
        ariaLabel="hourglass-loading"
        wrapperStyle={{}}
        wrapperClass=""
        colors={LOADER_COLORS}
      />
    </div>
  );
};

export const FullPageLoader = (props) => {
  const visible = props.visible;
  const extraClass = props.className || "";
  if (visible) {
    return (
      <div
        className={`loader-container${extraClass ? " " + extraClass : ""}`}
        style={{ display: "flex", justifyContent: "center", padding: "5px" }}
      >
        <Hourglass
          visible={true}
          height="30"
          width="30"
          ariaLabel="hourglass-loading"
          wrapperStyle={{}}
          wrapperClass=""
          colors={LOADER_COLORS}
        />
      </div>
    );
  }
};

export default Loader;
